import { PROJECT_BASE_URLS } from "@/constants/projectIds.ts"
import { removeLeadingSlash } from "@/lib/utils.ts"
import { NavigationGuard } from "vue-router"

const getProjectBasePath = (projectId: string) => PROJECT_BASE_URLS[projectId]

export const redirectGuard: NavigationGuard = async (to, _, next) => {
  const updatedQuery = { ...to.query }

  if (updatedQuery.redirect) {
    const redirectPath = removeLeadingSlash(updatedQuery.redirect.toString())
    const [projectId, ...routeParts] = redirectPath.split("/")
    const basePath = getProjectBasePath(projectId)

    if (basePath) {
      updatedQuery.redirect = encodeURIComponent(
        `${import.meta.env.VITE_PUBLIC_WEBSITE_URL}${basePath}/${routeParts.join("/")}`,
      )
    }

    if (to.path === to.query.redirect) {
      delete updatedQuery.redirect
    }
  }

  // If query parameters were updated, navigate with the new query
  if (JSON.stringify(updatedQuery) === JSON.stringify(to.query)) {
    next()
  } else {
    next({ path: to.path, query: updatedQuery, replace: true })
  }
}
